import React from 'react';
import { IconProps } from '../types';
const MinecraftLeatherBoots: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(207, 207, 207, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(83, 83, 83, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(179, 179, 179, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
</svg>);
export default MinecraftLeatherBoots;